module.exports = __webpack_public_path__ + "img/icon_map_js.679c0b1a.png";